export default function Context() {
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
          Empresas que crescem precisam de estratégia, não improviso
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
          À medida que o negócio evolui, marketing deixa de ser apenas operacional e passa a ser um pilar estratégico. Sem método, o crescimento se torna instável e difícil de sustentar.
        </p>
      </div>
    </section>
  );
}
